import styled, { createGlobalStyle, keyframes } from 'styled-components'

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(4px); }
  to   { opacity: 1; transform: translateY(0); }
`

// Mesma paleta e tipografia das outras telas do SantoLog (ver Auditoria).
const c = {
  bg: '#0a0c0f', bg2: '#111318', bg3: '#181c23', bg4: '#1e2330',
  bdr: '#1f2430', bdr2: '#2a3040',
  acc: '#00e5a0', acc2: '#00b87a',
  adim: 'rgba(0,229,160,.08)', adim2: 'rgba(0,229,160,.18)',
  txt: '#e8ecf0', txt2: '#8a95a3', txt3: '#5a6370',
  warn: '#f59e0b', danger: '#ef4444', info: '#3b82f6', purple: '#a855f7',
  mono: "'Space Mono',monospace", sans: "'DM Sans',sans-serif",
}

export const COLORS = c

export const GlobalStyles = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Space+Mono:wght@400;700&family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500;9..40,600;9..40,700&display=swap');
`

export const PageWrap = styled.div`
  background:${c.bg}; color:${c.txt}; font-family:${c.sans};
  height:100vh; display:flex; flex-direction:column; overflow:hidden;
`

export const Topbar = styled.div`
  background:${c.bg2}; border-bottom:1px solid ${c.bdr};
  padding:10px 16px; min-height:48px;
  display:flex; align-items:center; gap:14px; flex-shrink:0; flex-wrap:wrap;
  h2 { font-size:13px; font-weight:600; color:${c.txt}; }
  .crumb { font-size:11px; color:${c.txt3}; }
  .spacer { flex:1; }
`

export const Body = styled.div`
  flex:1; min-height:0; overflow-y:auto; background:${c.bg};
  &::-webkit-scrollbar { width:6px; }
  &::-webkit-scrollbar-thumb { background:${c.bdr2}; border-radius:3px; }
`

// ─── SLOTS DE UPLOAD ───────────────────────────────────────────────────────
export const SlotRow = styled.div`
  display:grid; grid-template-columns:repeat(auto-fit, minmax(300px,1fr));
  gap:12px; padding:14px 20px;
  background:${c.bg2}; border-bottom:1px solid ${c.bdr}; flex-shrink:0;
`

export const Slot = styled.div`
  background:${c.bg3}; border:1px solid ${({ $ok }) => ($ok ? c.adim2 : c.bdr2)};
  border-left:3px solid ${({ $ok }) => ($ok ? c.acc : c.bdr2)};
  border-radius:9px; padding:10px 14px;
  display:flex; align-items:center; gap:12px; min-width:0;

  .t { min-width:0; flex:1; }
  .t b {
    display:block; font-size:11px; font-weight:700; color:${c.txt2};
    text-transform:uppercase; letter-spacing:.06em;
  }
  /* O nome do arquivo pode ser longo: corta em vez de empurrar o botão. */
  .t small {
    display:block; font-size:12px; color:${({ $ok }) => ($ok ? c.txt : c.txt3)};
    white-space:nowrap; overflow:hidden; text-overflow:ellipsis; margin-top:2px;
  }
  .t small .when { color:${c.txt3}; font-family:${c.mono}; font-size:10px; }
`

export const UpBtn = styled.button`
  flex:none; background:${c.acc}; color:#000; border:none; border-radius:7px;
  padding:8px 14px; font-size:11px; font-weight:700; font-family:${c.sans};
  cursor:pointer; text-transform:uppercase; letter-spacing:.04em;
  &:hover:not(:disabled) { filter:brightness(1.1); }
  &:disabled { opacity:.5; cursor:progress; }
`

// ─── NÚMEROS DO TOPO ───────────────────────────────────────────────────────
export const Hero = styled.div`
  display:flex; flex-wrap:wrap; align-items:flex-end; gap:16px 40px;
  padding:20px 20px 16px; border-bottom:1px solid ${c.bdr};

  .total .lab, .stat .lab {
    font-size:10px; color:${c.txt3}; text-transform:uppercase;
    letter-spacing:.06em; font-weight:700;
  }
  .total .val {
    font-family:${c.mono}; font-weight:700; color:${c.acc};
    font-size:clamp(30px,4.4vw,46px); line-height:1.05; margin-top:2px;
  }
  .total .per { font-size:11px; color:${c.txt3}; margin-top:4px; }

  .stats { display:flex; flex-wrap:wrap; gap:14px 30px; padding-bottom:4px; }
  .stat .val {
    font-family:${c.mono}; font-weight:700; font-size:20px;
    color:${c.txt}; line-height:1.2; margin-top:2px;
  }
  .stat .val.alert { color:${c.warn}; }
`

// ─── ABAS ──────────────────────────────────────────────────────────────────
export const Tabs = styled.div`
  display:flex; gap:2px; padding:0 20px; background:${c.bg2};
  border-bottom:1px solid ${c.bdr}; overflow-x:auto; flex-shrink:0;
  &::-webkit-scrollbar { height:0; }

  button {
    background:none; border:none; cursor:pointer; white-space:nowrap;
    padding:11px 14px; font-size:12px; font-weight:600; font-family:${c.sans};
    color:${c.txt3}; border-bottom:2px solid transparent; margin-bottom:-1px;
    &:hover { color:${c.txt}; }
    &[aria-selected='true'] { color:${c.acc}; border-bottom-color:${c.acc}; }
  }
`

export const Panel = styled.section`
  padding:18px 20px;
  h3 {
    font-size:13px; font-weight:700; color:${c.txt}; margin:0 0 3px;
  }
  .sub { font-size:11.5px; color:${c.txt3}; margin:0 0 12px; max-width:80ch; line-height:1.45; }
`

export const Grid2 = styled.div`
  display:grid; grid-template-columns:repeat(auto-fit, minmax(min(100%,440px),1fr));
  gap:0 28px;
`

// ─── TABELAS ───────────────────────────────────────────────────────────────
export const TableWrap = styled.div`
  border:1px solid ${c.bdr}; border-radius:9px; background:${c.bg2};
  overflow:auto; max-width:100%;
  &::-webkit-scrollbar { width:6px; height:6px; }
  &::-webkit-scrollbar-thumb { background:${c.bdr2}; border-radius:3px; }

  table { border-collapse:collapse; width:100%; font-size:12px; }
  th, td {
    padding:8px 11px; text-align:left; white-space:nowrap;
    border-bottom:1px solid ${c.bdr};
  }
  th {
    background:${c.bg3}; color:${c.txt2}; font-size:10px; font-weight:700;
    text-transform:uppercase; letter-spacing:.06em;
    position:sticky; top:0; z-index:2;
  }
  th.n, td.n { text-align:right; }
  td { color:${c.txt}; }
  td.mono, th.mono { font-family:${c.mono}; font-size:11px; }
  tbody tr:last-child td { border-bottom:none; }
  tbody tr:hover td { background:${c.bg3}; }
  tfoot td {
    background:${c.bg3}; font-weight:700; color:${c.txt};
    border-top:1px solid ${c.bdr2}; border-bottom:none;
    position:sticky; bottom:0;
  }
  th.sort { cursor:pointer; user-select:none; &:hover { color:${c.acc}; } }
  th.sort[data-dir]{ color:${c.acc}; }
  td.dim { color:${c.txt3}; }
  /* Valor que a tabela de frete não cobriu — tem que saltar na conferência. */
  .vnull { color:${c.danger}; font-weight:700; }
`

/** Barra de participação dentro da célula. */
export const Bar = styled.div`
  display:flex; align-items:center; min-width:90px;
  i {
    display:block; height:6px; border-radius:3px; background:${c.acc2};
    min-width:2px; width:${({ $pct }) => $pct}%;
  }
`

export const Chip = styled.span`
  display:inline-flex; align-items:center; padding:2px 8px; border-radius:11px;
  font-size:9.5px; font-weight:700; text-transform:uppercase; letter-spacing:.04em;
  font-family:${c.sans}; margin-right:4px;
  background:${({ $bad }) => ($bad ? 'rgba(239,68,68,.15)' : 'rgba(245,158,11,.15)')};
  color:${({ $bad }) => ($bad ? '#f87171' : '#fbbf24')};
  border:1px solid ${({ $bad }) => ($bad ? 'rgba(239,68,68,.3)' : 'rgba(245,158,11,.3)')};
`

// ─── FILTROS ───────────────────────────────────────────────────────────────
export const Filters = styled.div`
  display:flex; flex-wrap:wrap; gap:8px; align-items:center; margin-bottom:12px;

  input, select {
    background:${c.bg3}; border:1px solid ${c.bdr2}; border-radius:7px;
    color:${c.txt}; padding:7px 10px; font-size:12px; font-family:${c.sans};
    outline:none; min-width:0;
    &:focus { border-color:${c.acc}; }
    &::placeholder { color:${c.txt3}; }
  }
  input[type='search'] { flex:1 1 230px; }
  select { cursor:pointer; option { background:${c.bg3}; color:${c.txt}; } }
`

export const Btn = styled.button`
  background:${({ $primary }) => ($primary ? c.acc : 'transparent')};
  color:${({ $primary }) => ($primary ? '#000' : c.txt2)};
  border:${({ $primary }) => ($primary ? 'none' : `1px solid ${c.bdr2}`)};
  padding:7px 13px; border-radius:7px; font-size:11px; cursor:pointer;
  font-family:${c.sans}; font-weight:${({ $primary }) => ($primary ? 700 : 600)};
  white-space:nowrap; transition:.12s;
  &:hover:not(:disabled) {
    ${({ $primary }) => ($primary ? 'filter:brightness(1.1);' : `border-color:${c.acc}; color:${c.acc};`)}
  }
  &:disabled { opacity:.4; cursor:not-allowed; }
`

export const Strip = styled.div`
  display:flex; flex-wrap:wrap; gap:4px 24px; font-size:11.5px;
  color:${c.txt3}; margin-bottom:10px;
  b { color:${c.txt}; font-family:${c.mono}; font-size:12.5px; margin-left:4px; }
`

export const Pagination = styled.div`
  display:flex; align-items:center; gap:10px; justify-content:flex-end;
  margin-top:10px; font-size:11.5px; color:${c.txt3};
  .page { color:${c.txt}; font-family:${c.mono}; }
`

// ─── ATENÇÃO ───────────────────────────────────────────────────────────────
export const Notice = styled.p`
  border-left:3px solid ${c.warn}; background:${c.bg2};
  border-radius:0 7px 7px 0; padding:9px 12px; margin:0 0 8px;
  font-size:11.5px; color:${c.txt2}; line-height:1.45;
`

export const AlertList = styled.div`display:flex; flex-direction:column; gap:8px;`

export const Alert = styled.div`
  display:flex; align-items:center; gap:12px; padding:10px 14px;
  border-radius:9px; background:${c.bg2};
  border:1px solid ${({ $bad }) => ($bad ? 'rgba(239,68,68,.3)' : 'rgba(245,158,11,.28)')};
  border-left:4px solid ${({ $bad }) => ($bad ? c.danger : c.warn)};
  animation:${fadeIn} .15s ease;

  .c {
    font-family:${c.mono}; font-weight:700; font-size:20px; min-width:40px;
    color:${({ $bad }) => ($bad ? '#f87171' : '#fbbf24')};
  }
  .d { flex:1; min-width:0; }
  .d b { display:block; font-size:12.5px; font-weight:600; color:${c.txt}; }
  .d small { font-size:11px; color:${c.txt3}; line-height:1.4; }
`

// ─── GRÁFICO ───────────────────────────────────────────────────────────────
export const Chart = styled.div`
  position:relative; border:1px solid ${c.bdr}; border-radius:9px;
  background:${c.bg2}; padding:12px 12px 4px;
  svg { display:block; width:100%; height:auto; }
  .tip {
    position:absolute; pointer-events:none; z-index:5;
    background:${c.bg4}; border:1px solid ${c.bdr2}; color:${c.txt};
    font-size:11px; font-family:${c.mono}; padding:6px 9px; border-radius:6px;
    white-space:nowrap; opacity:0; transition:opacity .1s;
  }
`

// ─── VAZIO ─────────────────────────────────────────────────────────────────
export const Empty = styled.div`
  border:1.5px dashed ${c.bdr2}; border-radius:12px; background:${c.bg2};
  padding:48px 24px; text-align:center; margin:30px 20px;
  h3 { font-size:16px; font-weight:700; color:${c.txt}; margin:0 0 8px; }
  p { font-size:12.5px; color:${c.txt3}; max-width:62ch; margin:0 auto; line-height:1.6; }
`

export const Toast = styled.div`
  position:fixed; left:50%; bottom:24px; transform:translateX(-50%);
  background:${c.bg4}; border:1px solid ${c.bdr2}; color:${c.txt};
  padding:10px 16px; border-radius:9px; font-size:12px; z-index:3000;
  max-width:calc(100% - 32px); pointer-events:none;
  opacity:${({ $on }) => ($on ? 1 : 0)}; transition:opacity .2s;
`
